import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconFlagUnitedKingdom = function IconFlagUnitedKingdom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-flag-united-kingdom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h33v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.867 0 12.581 9.05L28.978 0H33v3.1l-12.375 8.95L33 20.95V24h-4.125L16.5 15.05 4.177 24H0v-3l12.323-8.9L0 3.2V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M21.863 14.05 33 22v2l-13.973-9.95zm-9.488 1 .31 1.75-9.9 7.2H0zM33 0v.15l-12.84 9.4.104-2.2L30.422 0zM0 0l12.323 8.8H9.23L0 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.427 0v24h8.25V0zM0 8v8h33V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M0 9.65v4.8h33v-4.8zM14.077 0v24h4.95V0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-flag-united-kingdom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2a2 2 0 0 1 2-2h29a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  }))));
};